<script setup lang="ts">
import {
  LandingBanner,
  LandingFaq,
  LandingAppBanner,
  LandingPlaces,
  LandingSpend,
  LandingTariffs,
  LandingGet,
} from "@/modules/landing-module";
import { onBeforeMount } from "vue";
import { useLandingStore } from "./store/landing.store";

const landingStore = useLandingStore();

onBeforeMount(() => {
  if (!landingStore.offersCategories.length) {
    landingStore.loadLandingPage();
  }
});
</script>

<template>
  <main class="landing">
    <LandingBanner />

    <LandingGet />

    <LandingTariffs />

    <LandingSpend />

    <LandingPlaces />

    <LandingFaq />

    <LandingAppBanner />
  </main>
</template>

<style scoped lang="scss">
.landing {
  display: grid;
  grid-template-columns: 1fr;
  padding: ($base-space * 10) 0;
  gap: calc($base-space * 32);

  @media (max-width: 1239px) {
    gap: calc($base-space * 18);
    padding: calc($base-space * 8) 0;
    margin: calc($base-space * -12) 0 0;
  }

  @media (max-width: 1023px) {
    padding: calc($base-space * 5) 0;
  }
}
</style>
